import React, {PureComponent} from 'react';

import {connect} from '@stubhub/react-store-provider';

// Controller
import controller from './controller';

export default function EventInfoHeader(InnerComp) {
  @connect(controller)
  class EventInfoHeader extends PureComponent {
    render() {
      return <InnerComp {...this.props} />;
    }
  }

  return EventInfoHeader;
}
